// Expands/collapses the "+"-delimited description pills on the product
// page. Plain delegated listener at module scope (not a custom element),
// consistent with the rest of the theme — nothing here needs per-instance
// state beyond what's already on the DOM nodes themselves.
//
// The collapsed height is measured from the actual rendered pills (grouped
// into rows by vertical position) rather than a guessed pixel value — a
// fixed guess cuts whatever row happens to sit at that pixel in half
// whenever pill count/width/font-size changes, instead of always stopping
// on a row boundary.
//
// Row position is read via getBoundingClientRect(), not offsetTop —
// offsetTop is relative to the nearest *positioned* ancestor (offsetParent),
// which on this page is rarely the pills container itself, so it measured
// against the wrong reference frame and produced nonsense heights.
// getBoundingClientRect() is always viewport-relative regardless of any
// ancestor's positioning, so subtracting the container's own rect gives a
// reliable position relative to the container.
(function () {
  var ROWS_WHEN_COLLAPSED = 1;

  function collapsedHeightFor(pills) {
    var children = Array.from(pills.children);
    if (!children.length) return null;
    var containerTop = pills.getBoundingClientRect().top;
    var rects = children.map(function (el) {
      var r = el.getBoundingClientRect();
      return { top: Math.round(r.top - containerTop), bottom: Math.round(r.bottom - containerTop) };
    });
    var tops = [];
    rects.forEach(function (r) {
      if (tops.indexOf(r.top) === -1) tops.push(r.top);
    });
    tops.sort(function (a, b) { return a - b; });
    if (tops.length <= ROWS_WHEN_COLLAPSED) return null;
    var hideFromTop = tops[ROWS_WHEN_COLLAPSED];
    var maxBottom = 0;
    rects.forEach(function (r) {
      if (r.top < hideFromTop) maxBottom = Math.max(maxBottom, r.bottom);
    });
    return maxBottom;
  }

  // Drops the pixel cap once the expand transition finishes, so later reflow
  // (web fonts, resize, zoom) can grow the list instead of being clipped.
  function releaseCapAfterTransition(pills) {
    var done = function (e) {
      if (e && e.target !== pills) return;
      pills.removeEventListener('transitionend', done);
      clearTimeout(pills._flixCapTimer);
      if (pills.dataset.expanded === 'true') pills.style.maxHeight = 'none';
    };
    pills.addEventListener('transitionend', done);
    // Fallback for when no transition runs (reduced motion, instant styles).
    clearTimeout(pills._flixCapTimer);
    pills._flixCapTimer = setTimeout(done, 600);
  }

  function init() {
    document.querySelectorAll('[data-flix-desc-pills]').forEach(function (pills) {
      var wrap = pills.closest('[data-flix-desc-wrap]');
      var toggle = wrap && wrap.querySelector('[data-flix-desc-toggle]');
      if (!toggle) return;
      pills.style.maxHeight = 'none';
      var collapsed = collapsedHeightFor(pills);
      if (collapsed === null) {
        toggle.style.display = 'none';
        return;
      }
      toggle.style.display = '';
      pills.dataset.collapsedHeight = collapsed + 'px';
      if (pills.dataset.expanded === 'true') {
        // Already open: stay uncapped rather than re-freezing a stale height.
        pills.style.maxHeight = 'none';
      } else {
        pills.style.maxHeight = collapsed + 'px';
      }
    });
  }

  if (!window._flixDescToggleBound) {
    window._flixDescToggleBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-flix-desc-toggle]');
      if (!btn) return;
      var wrap = btn.closest('[data-flix-desc-wrap]');
      var pills = wrap && wrap.querySelector('[data-flix-desc-pills]');
      if (!pills) return;
      var expanded = pills.dataset.expanded === 'true';
      var label = btn.querySelector('[data-flix-desc-toggle-label]');
      var icon = btn.querySelector('[data-flix-desc-toggle-icon]');
      if (expanded) {
        if (pills.style.maxHeight === 'none') {
          pills.style.maxHeight = pills.scrollHeight + 'px';
          void pills.offsetHeight; // flush, so the transition has a start value
        }
        pills.style.maxHeight = pills.dataset.collapsedHeight || '0px';
        if (label) label.textContent = btn.dataset.showMoreText;
        if (icon) icon.style.transform = '';
      } else {
        pills.style.maxHeight = pills.scrollHeight + 'px';
        if (label) label.textContent = btn.dataset.showLessText;
        if (icon) icon.style.transform = 'rotate(180deg)';
        releaseCapAfterTransition(pills);
      }
      pills.dataset.expanded = expanded ? 'false' : 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Arabic web fonts (Tajawal) can still be downloading when this script
  // first runs — text renders in a fallback font temporarily, wraps
  // differently, and freezes a collapsed height measured against that
  // wrong layout. Re-measure once the real fonts are actually in place.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  }

  // Pill rows reflow on resize (text wraps differently at narrower widths),
  // so a collapsed height measured at one width can cut a row in half at
  // another — recompute whenever the viewport actually changes width.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-flix-desc-pills]').forEach(function (pills) {
        if (pills.dataset.expanded === 'true') return;
        init();
      });
    }, 200);
  });
})();
